import Default from "@/layouts/Default.vue";
import { WhereMatcher } from "@/utils/paramsHelper";
import PermissionsV1 from "@/router/permissions/v1";

export default [
  {
    path: "/",
    name: "DefaultLayout",
    component: Default,
    children: [
      {
        path: "/",
        name: "home",
        meta: { middleware: "auth" },
        component: () => import("../views/Home.vue"),
        redirect: "/selection",
      },
      {
        path: "/subdivisions",
        name: "subdivisions",
        meta: { middleware: ["auth"] },
        component: () => import("../views/Subdivisions.vue"),
      },
      {
        path: "/departments",
        name: "departments",
        meta: { middleware: "auth" },
        component: () => import("../views/Departments.vue"),
      },
      {
        path: "/employees",
        name: "employees",
        meta: { middleware: "auth" },
        component: () => import("../views/Employees.vue"),
      },
      {
        path: "/posts",
        name: "posts",
        meta: { middleware: "auth" },
        component: () => import("../views/Posts.vue"),
      },
      {
        path: "/accesses",
        name: "accesses",
        meta: { middleware: "auth" },
        component: () => import("../views/Accesses.vue"),
      },
      {
        path: "/orders",
        name: "orders",
        meta: { middleware: "auth" },
        component: () => import("../views/Orders.vue"),
      },
      {
        path: "/analytics",
        name: "analytics",
        meta: {
          middleware: "auth",
          accesses: PermissionsV1["STATISTICS.SELECTION.COUNTS_BY_TYPES"],
        },
        component: () => import("../views/Analytics.vue"),
      },
      //positions
      {
        path: "/positions/dashboard",
        name: "positions-dashboard",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.REQUESTS.DASHBOARD.SUMMARY"],
          accesses_redirect: true,
        },
        component: () => import("@/views/positions/Dashboard.vue"),
      },
      {
        path: "/requests/awaiting",
        name: "positions-requests-awaiting",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.REQUESTS.ON_AWAITING"],
          accesses_redirect: true,
        },
        component: () => import("@/views/positions/AwaitingRequests.vue"),
      },
      {
        path: "/requests/my-awaiting",
        name: "positions-requests-my-awaiting",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.REQUESTS.MY"],
          accesses_redirect: true,
        },
        component: () => import("@/views/positions/MyAwaitingRequests.vue"),
      },
      {
        path: "/positions",
        name: "positions-index",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.INDEX"],
          accesses_redirect: true,
        },
        component: () => import("@/views/positions/Index.vue"),
      },
      {
        path: "/positions/:id",
        name: "positions-show",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.SHOW"],
          accesses_redirect: true,
        },
        component: () => import("@/views/positions/ShowPosition.vue"),
      },
      {
        // Тот же компонент и то же право, что у positions-show: без guard
        // вкладка /positions/:id/:tabSlug открывалась без HRMIS.POSITIONS.SHOW.
        // accesses_redirect намеренно не ставим: он помечает маршрут как цель
        // для редиректа, а toNext переходит по имени без параметров - на
        // маршрут с :id так не попасть.
        path: "/positions/:id/:tabSlug",
        name: "positions-show-tabs",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.SHOW"],
        },
        component: () => import("@/views/positions/ShowPosition.vue"),
      },
      {
        // Подстраница должности, поэтому право то же, что у positions-show:
        // RequirePosition сам считает его предусловием (getPositionData
        // выходит без него) и попасть сюда можно только со страницы должности.
        // Права на разделы (form.requirement*, profile.requirements,
        // profile.skills, item.*) остаются в самих загрузчиках - каждый ловит
        // свою ошибку, и страница теряет только недоступную часть, поэтому
        // перечислять их здесь через accesses_every нельзя: это отрезало бы
        // тех, кому доступна часть страницы.
        path: "/positions/:id/require",
        name: "positions-require",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["HRMIS.POSITIONS.SHOW"],
        },
        component: () => import("@/views/positions/RequirePosition.vue"),
      },

      //selection
      {
        path: "/selection",
        name: "selection",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["SELECTIONS.INDEX"],
          accesses_redirect: true,
        },
        component: () => import("../views/selection/Index.vue"),
      },
      {
        path: "/selection/create",
        name: "selection-create",
        meta: {
          middleware: "auth",
        },
        redirect: "/selection/create/general",
      },
      {
        path: "/selection/create/:page",
        name: "selection-create-page",
        meta: { middleware: "auth" },
        component: () => import("../views/selection/create/_slug.vue"),
      },
      {
        path: "/selection/create/:page/:selectionId",
        name: "selection-create-update-page",
        meta: { middleware: "auth" },
        component: () => import("../views/selection/create/_slug.vue"),
      },

      {
        path: "/selection/detail/:id/:stageSlug",
        name: "selection-detail",
        meta: { middleware: "auth" },
        component: () => import("../views/selection/_detail.vue"),
      },
      {
        path: "/selection/detail/:id",
        name: "selection-detail-main",
        meta: { middleware: "auth" },
        component: () => import("../views/selection/_detail.vue"),
      },

      //setting
      {
        path: "/setting/translations",
        name: "setting-translations",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/translations/List.vue"),
      },
      //setting-contest
      {
        path: "/setting/contest",
        name: "setting-contest",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/contest/Index.vue"),
      },
      {
        path: "/setting/contest/:id/:page",
        name: "setting-contest-detail",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/contest/_detail.vue"),
      },
      {
        path: "/setting/contest/update/:id",
        name: "setting-contest-update",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/contest/_update.vue"),
      },
      {
        path: "/setting/contest/:id/stages/:page/:stagesId",
        name: "setting-stages-detail",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/contest/StagesDetail.vue"),
      },
      {
        path: "/setting/contest/selection-address",
        name: "setting-selection-address",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/contest/SelectionAddress.vue"),
      },
      {
        path: "/setting/notification-accesses",
        name: "setting-notification-accesses",
        meta: { middleware: "auth" },
        component: () => import("../views/setting/Notification/Accesses.vue"),
      },
      {
        path: "/setting/alerts",
        name: "setting-alerts",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["POSITION_RATING_ALERTS.INDEX"],
        },
        component: () => import("../views/setting/alerts/Index.vue"),
      },

      {
        path: "settings-portal",
        name: "settings-portal",
        children: [
          {
            path: "",
            name: "settings-portal-index",
            meta: { middleware: ["auth"] },
            component: () => import("@/views/setting/portal/Index.vue"),
          },
          {
            path: "seo",
            name: "settings-portal.seo.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["SETTINGS.SEO.INDEX"],
            },
            component: () => import("@/views/setting/seo/Seo.vue"),
          },
          {
            path: "advantage",
            name: "settings-portal.advantage.index",
            meta: { middleware: ["auth"] },
            component: () => import("@/views/setting/advantage/Index.vue"),
          },
          {
            path: "handbook",
            name: "settings-portal.handbook.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["HANDBOOKS.INDEX"],
            },
            component: () => import("@/views/setting/handbook/Index.vue"),
          },
          {
            path: "pages",
            name: "settings-portal.pages.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["PORTAL_PAGES.INDEX"],
            },
            component: () => import("@/views/setting/pages/Index.vue"),
          },
          {
            path: "pages/:id",
            name: "settings-portal.pages.view",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["PORTAL_PAGES.SHOW"],
            },
            component: () => import("@/views/setting/pages/View.vue"),
          },
          {
            path: "organization",
            name: "settings-portal.organization.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["HRMIS.STATES.PORTAL_ORGANIZATIONS"],
            },
            component: () => import("@/views/setting/organization/Index.vue"),
          },
          {
            path: "organization/:id",
            name: "settings-portal.organization.view",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["HRMIS.STATES.VIEW"],
            },
            component: () => import("@/views/setting/organization/View.vue"),
          },
        ],
      },

      {
        path: "/persons",
        name: "persons",
        children: [
          {
            path: "",
            name: "persons.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["PERSONS.INDEX"],
              accesses_redirect: true,
            },
            component: () => import("@/views/person/Persons.vue"),
          },
          {
            path: ":id/access",
            name: "persons.access",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["PERSONS.SHOW"],
            },
            component: () => import("@/views/person/PersonAccess.vue"),
          },
          {
            path: ":id",
            name: "persons.show",
            meta: {
              middleware: ["auth", "has_access", "person_access_to_view"],
              accesses: PermissionsV1["PERSONS.SHOW"],
            },
            component: () => import("@/views/person/ShowPerson.vue"),
            beforeEnter: WhereMatcher.bind({
              id: /^\d+$/,
            }),
          },
        ],
      },
      {
        path: "/users",
        name: "users",
        children: [
          {
            path: "",
            name: "users.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/users/Users.vue"),
          },
          {
            path: "create",
            name: "users.create",
            meta: { middleware: "auth" },
            component: () => import("../views/users/CreateUser.vue"),
          },
          {
            path: ":id",
            name: "users.show",
            meta: { middleware: "auth" },
            component: () => import("@/views/users/ShowUser.vue"),
            beforeEnter: WhereMatcher.bind({
              id: /^\d+$/,
            }),
          },
          {
            path: "update/:id",
            name: "users.update",
            meta: { middleware: "auth" },
            component: () => import("@/views/users/UpdateUser.vue"),
            beforeEnter: WhereMatcher.bind({
              id: /^\d+$/,
            }),
          },
        ],
      },
      {
        path: "/skills",
        name: "skills",
        children: [
          {
            path: "",
            name: "skills.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/skills/Skills.vue"),
          },
          // создание и редактирование навыка теперь в модальном окне на списке
          { path: "create", redirect: "/skills" },
          { path: "update/:id", redirect: "/skills" },
        ],
      },
      {
        path: "/skills/groups",
        name: "skill_groups",
        children: [
          {
            path: "",
            name: "skill_groups.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/skills/groups/GroupSkills.vue"),
          },
          // создание и редактирование группы теперь в модальном окне на списке
          { path: "create", redirect: "/skills/groups" },
          { path: "update/:id", redirect: "/skills/groups" },
        ],
      },

      {
        path: "/permissions",
        name: "permissions",
        children: [
          {
            path: "",
            name: "permissions.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/permissions/Permissions.vue"),
          },
          {
            path: "create",
            name: "permissions.create",
            meta: { middleware: "auth" },
            component: () => import("@/views/permissions/CreatePermission.vue"),
          },
          {
            path: "update/:id",
            name: "permissions.update",
            meta: { middleware: "auth" },
            component: () => import("@/views/permissions/UpdatePermission.vue"),
            beforeEnter: WhereMatcher.bind({
              id: /^\d+$/,
            }),
          },
        ],
      },

      {
        path: "/news",
        name: "news",
        children: [
          {
            path: "",
            name: "news.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/news/News.vue"),
          },
          {
            path: "create",
            name: "news.create",
            meta: { middleware: "auth" },
            component: () => import("@/views/news/CreateNews.vue"),
          },
          {
            path: "update/:id",
            name: "news.update",
            meta: { middleware: "auth" },
            component: () => import("@/views/news/UpdateNews.vue"),
            beforeEnter: WhereMatcher.bind({
              id: /^\d+$/,
            }),
          },
        ],
      },

      {
        path: "/commissions",
        name: "commissions",
        children: [
          {
            path: "",
            name: "commissions.index",
            meta: {
              middleware: ["auth", "has_access"],
              accesses: PermissionsV1["HRMIS.STATES.COMMISSIONS.INDEX"],
              accesses_redirect: true,
            },
            component: () => import("@/views/commissions/Commissions.vue"),
          },
          {
            path: "create",
            name: "commissions.create",
            meta: { middleware: "auth" },
            component: () => import("@/views/commissions/CreateCommission.vue"),
          },
          {
            path: "update/:id/update",
            name: "commissions.update",
            meta: { middleware: "auth" },
            component: () => import("@/views/commissions/UpdateCommission.vue"),
          },
        ],
      },

      {
        path: "/handbooks",
        name: "handbooks",
        children: [
          {
            path: "",
            name: "handbooks.index",
            meta: { middleware: "auth" },
            component: () => import("@/views/handbooks/Handbooks.vue"),
          },
          {
            path: "values/:valueId",
            name: "handbooks.values.show",
            meta: { middleware: "auth" },
            component: () => import("@/views/handbooks/ShowHandbookValue.vue"),
          },
          {
            path: ":id",
            name: "handbooks.show",
            meta: { middleware: "auth" },
            component: () => import("@/views/handbooks/ShowHandbook.vue"),
          },
        ],
      },
      {
        path: "/reports",
        name: "reports",
        meta: { middleware: "auth" },
        component: () => import("@/views/reports/Index.vue"),
      },
      {
        path: "/rating",
        name: "rating",
        meta: {
          middleware: ["auth", "has_access"],
          accesses: PermissionsV1["RATING.INDEX"],
          accesses_redirect: true,
        },
        component: () => import("@/views/rating/Index.vue"),
      },
      {
        path: "/403",
        name: "403",
        component: () => import("@/views/403.vue"),
      },
      {
        path: "/notifications",
        name: "notifications",
        meta: { middleware: "auth" },
        component: () => import("@/views/profile/Notifications.vue"),
      },
    ],
  },
];
